var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwiter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.5,
    stroke: "#46A358",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0319 22.0036C19.0699 22.0036 22.3718 17.0012 22.3718 12.6636C22.3718 12.5214 22.3689 12.38 22.3624 12.2392C23.0033 11.7759 23.5605 11.1976 24 10.5395C23.4118 10.8008 22.7789 10.9768 22.1149 11.0562C22.7926 10.6498 23.313 10.0067 23.5585 9.24021C22.9241 9.61636 22.2217 9.88969 21.4742 10.0371C20.8749 9.39908 20.0218 9 19.0779 9C17.2648 9 15.7946 10.4702 15.7946 12.2823C15.7946 12.54 15.8236 12.7904 15.8796 13.0308C13.1516 12.8938 10.7324 11.5874 9.11352 9.60125C8.83127 10.0862 8.66877 10.65 8.66877 11.2511C8.66877 12.3899 9.24837 13.3953 10.1297 13.9836C9.59121 13.9671 9.08531 13.8189 8.64293 13.5729C8.6422 13.5866 8.6422 13.6004 8.6422 13.6148C8.6422 15.2047 9.77392 16.532 11.2758 16.8329C11.0001 16.908 10.71 16.9484 10.4105 16.9484C10.199 16.9484 9.99338 16.9273 9.79339 16.8893C10.2112 18.1933 11.4232 19.1425 12.8601 19.1693C11.7364 20.0499 10.3209 20.5745 8.78305 20.5745C8.51827 20.5745 8.25695 20.5594 8 20.529C9.45273 21.46 11.1777 22.0036 13.0319 22.0036Z",
    fill: "#46A358",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwiter);
export default __webpack_public_path__ + "static/media/twiter.90a9d506c52247390087336f6111bdec.svg";
export { ForwardRef as ReactComponent };